export class EppraisalParameters {

    static instance = {
        template: require('./EppraisalParameters.html'),
        controller: ['$scope', EppraisalParameters],
        bindings: {
            eppraisal: '<'
        }
    };

    constructor($scope) {
        this.$scope = $scope;
    }

    $onInit = () => {
        this.$scope.eppraisal = this.eppraisal;
    }
}